import { components, MenuProps, GroupBase } from 'react-select'

import styles from './Menu.module.scss'

export const Menu = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: MenuProps<Option, IsMulti, Group>
) => <components.Menu {...props} className={styles.root} />
